import React from "react"
import MaskedInput from "react-text-mask"

export default function HoraMask(props: any) {
    const { inputRef, ...other } = props

    return (
        <MaskedInput
            {...other}
            ref={ref => {
                inputRef(ref ? ref.inputElement : null)
            }}
            mask={[/[0-2]/, /\d/, ":", /[0-5]/, /\d/]}
            placeholderChar={"\u2000"}
            // showMask
        />
    )
}
